table.settings {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
table.settings tr > td:first-child {
    width: 65%;
  }
table.settings.bigger-output tr > td:first-child {
      width: 40%;
    }
table.settings.biggest-output tr > td:first-child {
      width: 25%;
    }
table.settings .option,
  table.settings .filter {
    color: var(--color-dark-brick);
  }
table.settings .flag,
  table.settings .output {
    color: var(--color-medium-green);
  }
table.settings p.default {
    margin-top: -0.5em;
    font-weight: bold;
  }
table.settings p.default code {
      font-size: 1em;
      color: green;
    }
table.settings th,
  table.settings td {
    border: 1px solid var(--sl-color-neutral-200);
    border-width: 0 0 1px;
    padding: 0.7em 0.75em;
    vertical-align: top;
  }
table.settings th:first-child, table.settings td:first-child {
      background: var(--sl-color-neutral-50);
    }
table.settings th p:last-of-type, table.settings td p:last-of-type {
      margin-bottom: 0;
    }
table.settings th {
    text-align: left;
    text-transform: uppercase;
    border-width: 0 0 2px;
  }
table.settings tbody > tr:last-child > td {
    border-bottom: none;
  }
@media screen and (max-width: 700px) {
      table.settings th:first-child:before {
        content: "👇 ";
      }
      table.settings th:last-child:after {
        content: " 👇";
      }
    table.settings th,
    table.settings td {
      display: block;
      width: 100% !important;
    }
      table.settings th:last-child, table.settings td:last-child {
        text-align: right !important;
      }
  }

/*# sourceMappingURL=data:application/json;base64,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 */